import { c as _c } from "react/compiler-runtime";
import { usePriceBox } from "@website/accommodation-ui/price-calendar-wrapper/price-box/hooks";
import { PriceCalendarItem } from "@website/accommodation-ui/price-calendar-wrapper/types";
const sliderClassNames = "keen-slider__slide flex";
export const PriceBox = properties => {
  const $ = _c(15);
  const {
    isTodayPrice,
    price
  } = properties;
  const {
    formattedDate,
    formattedDateMobile,
    formattedPrice,
    priceBoxBgColor,
    priceColor,
    handleClick
  } = usePriceBox(properties);
  const t0 = `${sliderClassNames} min-w-[88px] cursor-pointer flex-col items-center justify-center gap-1 rounded-lg px-2 py-[6px] align-middle md:mx-1 md:min-w-[98px] md:first:mr-0 md:last:ml-0 lg:min-w-[104px] ${priceBoxBgColor} ${isTodayPrice ? "border-secondary border-2" : "border"}`;
  let t1;
  if ($[0] !== formattedDateMobile) {
    t1 = <span className="md:hidden">{formattedDateMobile}</span>;
    $[0] = formattedDateMobile;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== formattedDate) {
    t2 = <span className="hidden md:block">{formattedDate}</span>;
    $[2] = formattedDate;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <span className="text-on-surface-medium-emphasis text-caption whitespace-nowrap">{t1}{t2}</span>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `whitespace-nowrap text-sm ${price > 0 ? priceColor : "text-gray-400"}`;
  let t5;
  if ($[7] !== formattedPrice || $[8] !== t4) {
    t5 = <span className={t4}>{formattedPrice}</span>;
    $[7] = formattedPrice;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== handleClick || $[11] !== t0 || $[12] !== t3 || $[13] !== t5) {
    t6 = <div className={t0} onClick={handleClick}>{t3}{t5}</div>;
    $[10] = handleClick;
    $[11] = t0;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};